// @ts-ignore: autogenerated import
import type * as Types from '../../../types/global';

import { gql } from '@apollo/client';
export type ImageModuleFragment = {
	__typename?: 'ModuleImage';
	altText?: string | null;
	copyright?: string | null;
	title?: string | null;
	url?: string | null;
};

export const ImageModuleFragmentDoc = gql`
	fragment ImageModule on ModuleImage {
		altText
		copyright
		title
		url
	}
`;
